import {Model} from '@vuex-orm/core';
import User from '../../users/models/User';
import CourseRole from '../../users/models/CourseRole';
import CourseLikeAssignment from '@/assignments/models/CourseLikeAssignment';
import {ModelFields} from '@/orm/types/ModelFields';
import Fields from '@vuex-orm/core/lib/model/contracts/Fields';
import {Joined} from '@/orm/types/Joined';
import {RawCourseLike} from '@/courses/types/RawCourseLike';
import {CourseSection, Course} from '@/courses/models';

export type CourseLikeFields = ModelFields<CourseLike>;

/**
 * CourseLike class
 */
export class CourseLike
  extends Model
  implements Omit<RawCourseLike, 'courseRoles' | 'courseLikeAssignments' | 'sections'>
{
  static entity = 'CourseLike';

  id!: number;
  name!: string;
  description!: string | null;
  color!: string | null;
  courseId!: number;
  course!: Joined<Course>;
  parentId!: number | null;
  sectionIds!: number[];
  sections!: Joined<CourseSection[]>;
  topLevelCourseId!: number;
  participants!: Joined<User[]>;
  courseRoles!: Joined<CourseRole[]>;
  courseLikeAssignments!: Joined<CourseLikeAssignment[]>;
  invitationsSent!: boolean;
  gradeDisplay!: string;
  draftsEnabled!: boolean;
  languagePreference!: string;
  inAppPaymentEnabled!: boolean;

  static fields(): Fields {
    return {
      id: this.number(null),
      name: this.string(''),
      description: this.string(null).nullable(),
      color: this.string(null).nullable(),
      topLevelCourseId: this.number(null),
      topLevelCourse: this.belongsTo(Course, 'topLevelCourseId'),
      courseId: this.number(0),
      course: this.belongsTo(Course, 'courseId'),
      parentId: this.number(null).nullable(),
      sectionIds: this.attr([]),
      sections: this.hasManyBy(CourseSection, 'sectionIds'),
      participants: this.belongsToMany(User, CourseRole, 'courseLikeId', 'userId'),
      courseRoles: this.hasMany(CourseRole, 'courseLikeId'),
      courseLikeAssignments: this.hasMany(CourseLikeAssignment, 'courseLikeId'),
      invitationsSent: this.boolean(false),
      gradeDisplay: this.string('percentage'),
      inAppPaymentEnabled: this.boolean(false),
      draftsEnabled: this.boolean(true),
      languagePreference: this.string('en'),
    };
  }
}

export default CourseLike;
